/**
 * This Software is the property of dotfly and is protected
 * by copyright law - it is NOT Freeware.
 *
 * Any unauthorized use of this software without a valid license key
 * is a violation of the license agreement and will be prosecuted by
 * civil and criminal law.
 *
 * @category   Fine
 * @author     Sascha Doerrenbach <sascha.doerrenbach@dotfly.de>
 * @license    http://www.dotfly.de Commercial
 * @link       http://www.dotfly.de
 */

var Fine = {

    /**
     * init/constructor method
     */
    init : function() {
        this.domReady();
        this.onLoad();
		this.onResize();
		this.onResizeThrottle();
        this.onScroll();
        this.onOrientationchange();
    },

    /**
     * Binding for domReady-Event
     * Note: we don't need to wrap this with $(function() {}) because
     * at this stage we effectively have parsed the whole DOM already
     */
    domReady : function() {
        document.addEventListener('DOMContentLoaded', function(){
            // = Stuff
        });
    },

    /**
     * Binding for onLoad-Event
     */
    onLoad : function() {
        window.addEventListener('load', function() {
            // = Stuff
        });
    },

	/**
     * Binding for onResize-Event
     */
    onResize : function() {
        let _iWidth = window.innerWidth;
        window.addEventListener('resize', function() {
            if(window.innerWidth != _iWidth) {
                // = Stuff
                _iWidth = window.innerWidth;
            }
        });
    },

    /**
     * Binding for onResize-Event (Throttle 500ms)
     */
    onResizeThrottle : function() {
        let resized;

        window.addEventListener('resize', function() {
            clearTimeout(resized);
            // = Stuff
            resized = setTimeout(doneResizing, 500);
        });

        function doneResizing() {
            // = Stuff
        }
    },

    /**
     * Binding for onResize-Event
     */
    onScroll : function() {
        window.addEventListener('scroll', function() {
            // = Stuff
        });
    },

    /**
     * Binding for onOrientationchange-Event
     */
    onOrientationchange : function() {
        window.addEventListener('orientationchange', function() {
            // = Stuff
        });
    }
};

// Init
Fine.init();
